export default __webpack_public_path__ + "static/media/font.bc67b3db.woff";